// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cVZ15jgVrosnKMBqXXLN{width:532px;min-width:492px;max-width:100%}.cVZ15jgVrosnKMBqXXLN .j_eTM4O3J9cxjCzrp0Rt{max-width:240px;padding:11px 8px 11px 12px}.cVZ15jgVrosnKMBqXXLN .j_eTM4O3J9cxjCzrp0Rt>div{white-space:nowrap;text-overflow:ellipsis;display:block;overflow:hidden}.cVZ15jgVrosnKMBqXXLN .StbHsvrMQl2bPhaUVoMi{padding:12px}.cVZ15jgVrosnKMBqXXLN .FB2eCvBXyEgSAiBD2mcH{align-items:center;min-height:40px;padding:8px 9px 8px 8px}.cVZ15jgVrosnKMBqXXLN .vhg80WYj_MA4Dj7nMIqh{margin:8px 0 24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `cVZ15jgVrosnKMBqXXLN`,
	"businessSelect": `j_eTM4O3J9cxjCzrp0Rt`,
	"selectPadding": `StbHsvrMQl2bPhaUVoMi`,
	"selectRegionsPadding": `FB2eCvBXyEgSAiBD2mcH`,
	"noEmailCheckbox": `vhg80WYj_MA4Dj7nMIqh`
};
export default ___CSS_LOADER_EXPORT___;
